export enum TransliterationMethod {
  IKAO = 0,
  Phonetic = 1,
}

export class TransliterationRule {
  public input: string;
  public output: string;
}
